import * as Yup from 'yup'
import LookupType from './LookupType'

const InventoryEntry = Yup.object().shape({
    id: Yup.number().nullable(),
    count_date: Yup.string(),
    individual_count: Yup.number().nullable(),
    inventory_cost: Yup.number().nullable(),
    location: LookupType,
    product: LookupType,
    total_units: Yup.number().nullable(),
    unit_count: Yup.number().nullable()
})

export const InventorySchema = Yup.object().shape({
    update_date: Yup.string(),
    inventory: Yup.array().of(InventoryEntry)
})
